import tms4ax  from  './tms4axios';

export default class TMSBaseService  {
    resource$ = tms4ax;
}